import { useMemo, useState } from "react";
import { useFormik } from "formik";

import {
  Container,
  Grid,
  Box,
  Card,
  CardContent,
  Button,
  TextField,
  Link,
  Typography,
  LinearProgress,
  Theme,
  useTheme,
} from "@mui/material";

import { sendResetPasswordAPI } from "../../Utils/API/apiAuth";
import { emailValidation } from "../../Utils/Custom/validations";

import { pathRoute } from "../../Utils/Routes/routes";
import ConfirmationSuccessSentResetPassword from "./components/ConfirmationSuccessSentResetPassword";
import Copyright from "../../Utils/Custom/Copyright";

export default function ForgotPassword() {
  const theme: Theme = useTheme();
  const classes = useMemo(
    () => ({
      paper: {
        marginTop: theme.spacing(15),
        display: "flex",
        // flexDirection: "column",
        alignItems: "center",
      },
      form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
      },
      submit: {
        margin: theme.spacing(2, 0, 2),
      },
      subTitle: {
        margin: theme.spacing(0, 0, 1),
      },
    }),
    []
  );
  const [loading, setLoading] = useState(false);
  const [showMessageSuccess, setShowMessageSuccess] = useState(false);

  const resetPassword = async (values: any) => {
    setLoading(true);

    await sendResetPasswordAPI(values?.email as any)
      .then((response: any) => {
        if (!response.data.hasErrors) {
          setShowMessageSuccess(true);
        }
      })
      .catch(function (error: any) {
        //interceptor capture the error
      })
      .finally(() => {
        setLoading(false);
      });

    setLoading(false);
  };

  const validate = (values: { email: string }) => {
    const errors: any = {};
    if (emailValidation(values.email)) {
      errors.email = emailValidation(values.email);
    }
    return errors;
  };
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validate,
    onSubmit: async (values: any) => {
      await resetPassword(values);
    },
    onReset: (values: any) => {
      //
    },
  });
  let emptyForm = true;
  if (formik.values.email) {
    emptyForm = false;
  }
  return (
    <Container component="main" maxWidth="xs">
      <div style={classes.paper}>
        {showMessageSuccess ? (
          <ConfirmationSuccessSentResetPassword />
        ) : (
          <>
            <Card sx={{ backgroundColor: theme.palette.background.paper }}>
              <CardContent>
                <Grid container flexDirection="column" alignItems="center" sx={{ my: 2 }}>
                  <img
                    src={
                      theme.palette.mode === "light"
                        ? "/images/anavio-logo-light.svg"
                        : "/images/anavio-logo.svg"
                    }
                    alt="Anavio logo"
                    style={{ width: "200px" }}
                  />
                  <Typography component="h1" variant="h5" color="primary" sx={{ mt: 2 }}>
                    Password Recovery
                  </Typography>
                </Grid>
                <form
                  style={classes.form}
                  onSubmit={formik.handleSubmit}
                  onReset={formik.handleReset}
                >
                  <Grid container justifyContent="flex-start">
                    <Grid item style={classes.subTitle}>
                      <Typography component="h1" variant="body2">
                        Forgot your account’s password? Enter your email address and we will send
                        you a recovery link.
                      </Typography>
                    </Grid>
                  </Grid>
                  <TextField
                    size="small"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    id="email"
                    label="Email"
                    autoComplete="email"
                    {...formik.getFieldProps("email")}
                    disabled={formik.isSubmitting}
                    error={formik.touched.email && formik.errors.email ? true : false}
                    helperText={
                      formik.touched.email && formik.errors.email ? formik.errors.email : ""
                    }
                  />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    sx={classes.submit}
                    disabled={formik.isSubmitting || emptyForm}
                  >
                    Continue
                  </Button>
                  <Grid container justifyContent="flex-end">
                    <Grid item>
                      <Link href={pathRoute.SignIn.Index} variant="body2">
                        Return to sign in
                      </Link>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </>
        )}
      </div>
      {loading ? <LinearProgress /> : null}
      <Box mt={2}>
        <Copyright />
      </Box>
    </Container>
  );
}
